"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CurrentSprintTab;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const ScrumboardController_1 = require("../ScrumboardController");
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
const useScrumboardEvents_1 = require("../useScrumboardEvents");
const ContractsListPanel_1 = __importDefault(require("./ContractsListPanel"));
const ContractTreePanel_1 = __importDefault(require("./ContractTreePanel"));
function CurrentSprintTab() {
    const [contracts, setContracts] = (0, react_1.useState)([]);
    const [discussedByContractId, setDiscussedByContractId] = (0, react_1.useState)(new Map());
    const [selectedContract, setSelectedContract] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(null);
    async function loadAll() {
        try {
            const [contractsList, statuses] = await Promise.all([
                ScrumboardController_1.scrumContractsListRepository.loadItemsFromServerPOST([{ typesToInclude: "our", statuses: [MainSetupReact_1.default.ContractStatuses.IN_PROGRESS] }], undefined, { skipCache: true }),
                ScrumboardApi_1.default.getContractStatuses(),
            ]);
            setContracts(contractsList.filter((c) => !/AQM/i.test(c._ourType || "")));
            setDiscussedByContractId(new Map(statuses.map((s) => [s.contractId, s.discussed])));
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    (0, react_1.useEffect)(() => {
        // upewnij się, że lista osób (do filtra) jest załadowana
        if (!MainSetupReact_1.default.personsEnviRepository?.items?.length) {
            MainSetupReact_1.default.personsEnviRepository
                ?.loadItemsFromServerPOST([{ systemRoleName: "ENVI_EMPLOYEE" }])
                .catch(() => undefined);
        }
        loadAll();
    }, []);
    // Real-time: aktualizacja checkboxów omówienia
    (0, useScrumboardEvents_1.useScrumboardEvents)({
        "contract-discussed-changed": (payload) => {
            setDiscussedByContractId((prev) => {
                const next = new Map(prev);
                next.set(payload.contractId, payload.discussed);
                return next;
            });
        },
        "discussed-reset": () => setDiscussedByContractId(new Map()),
    }, loadAll // po reconnekcie pełny refetch
    );
    async function toggleDiscussed(contractId, discussed) {
        // optymistycznie
        setDiscussedByContractId((prev) => new Map(prev).set(contractId, discussed));
        try {
            await ScrumboardApi_1.default.setContractDiscussed(contractId, discussed);
        }
        catch (err) {
            setDiscussedByContractId((prev) => new Map(prev).set(contractId, !discussed));
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error)),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { md: "3" },
                react_1.default.createElement(ContractsListPanel_1.default, { contracts: contracts, discussedByContractId: discussedByContractId, selectedContractId: selectedContract?.id, onSelectContract: setSelectedContract, onToggleDiscussed: toggleDiscussed })),
            react_1.default.createElement(react_bootstrap_1.Col, { md: "9" },
                react_1.default.createElement(ContractTreePanel_1.default, { contract: selectedContract })))));
}
